import { createTracker as createTrackerAuth } from 'usage-tracker';
import { createTracker as createTrackerAnonymous } from 'usage-tracker-anonymous';
import { makeUuid } from 'usage-tracker-core/common/helpers';
import events from '../../events.yaml';
import { getIsStaticPublicUrl } from './urls';
export const createTracker = getIsStaticPublicUrl() ? createTrackerAnonymous : createTrackerAuth;
export const usageTracker = createTracker(Object.assign({
  events
}, getIsStaticPublicUrl() && {
  properties: {
    email: null,
    hubId: null,
    lang: null,
    deviceId: makeUuid()
  }
}));